module.exports = __webpack_public_path__ + "img/Support-skill-629.1cd94455.png";